import { api } from "./client";
import type { ApiResponse } from "./types";

// Mirrors apps/api/src/modules/settings/settings.schema.ts exactly.

export type ProfileVisibility =
  | "everyone"
  | "indians_only"
  | "same_state_only"
  | "connections_only";

export type LocationVisibility =
  | "exact_city"
  | "state_only"
  | "country_only"
  | "hidden";

export interface PrivacySettings {
  profileVisibility: ProfileVisibility;
  locationVisibility: LocationVisibility;
  showContactOnMatch: boolean;
  /** Be counted as going when a match looks at an event. Opt-out, on by default. */
  showAttendance: boolean;
  /** Standing display consent — opt-IN, each defaults off. */
  standingShowVisaStatus: boolean;
  standingShowAdditionalRoots: boolean;
  standingShowRaisedIn: boolean;
  /** Your Parichay says "Part of a Ghar on WeDeshi". Opt-IN, off by default. */
  showHouseholdOnParichay: boolean;
}

export interface NotificationPrefs {
  events: boolean;
  services: boolean;
  newsletter: boolean;
  directMessages: boolean;
  communityAlerts?: boolean;
  questionReplies?: boolean;
  mentions?: boolean;
}

export function getPrivacySettings() {
  return api.get<ApiResponse<PrivacySettings>>("/settings/privacy");
}

export function updatePrivacySettings(input: Partial<PrivacySettings>) {
  return api.patch<ApiResponse<PrivacySettings>>("/settings/privacy", input);
}

export function getNotificationPrefs() {
  return api.get<ApiResponse<NotificationPrefs>>("/settings/notifications");
}

export function updateNotificationPrefs(input: Partial<NotificationPrefs>) {
  return api.patch<ApiResponse<NotificationPrefs>>(
    "/settings/notifications",
    input,
  );
}
